import { isAxiosError } from 'axios'

import httpClient from '../../httpClient.ts'

const getSubscriptionPricing = async () => {
  try {
    const response = await httpClient.get(
      '/api/subscription/get_pricing/'
    )
    return response.data
  } catch (error) {
    if (isAxiosError(error)) {
    }
    throw new Error('An unexpected error occurred')
  }
}

const subscriptionCreateSessions = async (data: { price_id: string }) => {
  try {
    const response = await httpClient.post(
      '/api/subscription/create_session/',
      data
    )
    return response.data
  } catch (error) {
    if (isAxiosError(error)) {
    }
    throw new Error('An unexpected error occurred')
  }
}

const getCustomerPortalLink = async () => {
  try {
    const response = await httpClient.get(
      '/api/subscription/get_customer_portal_link/'
    )
    return response.data
  } catch (error) {
    if (isAxiosError(error)) {
    }
    throw new Error('An unexpected error occurred')
  }
}

export const subscriptionAPI = {
  getSubscriptionPricing,
  subscriptionCreateSessions,
  getCustomerPortalLink,
}
